import { Component } from '@angular/core';
import { CommonService } from 'src/app/services/Common-function/common.service';

@Component({
  selector: 'ipm-seller-confirmation-popup',
  templateUrl: './seller-confirmation-popup.component.html',
  styleUrls: ['./seller-confirmation-popup.component.scss']
})
export class SellerConfirmationPopupComponent {

  isAccepted: boolean = false;

  constructor(private commonService: CommonService) {}

  onSubmit(): void {
    if (!this.isAccepted) return;
    this.closeWithAgreed();
  }

  onClose(): void {
    this.commonService.closePopUp();
  }

  private closeWithAgreed(): void {
    this.commonService.closingPopupWithSendData('agreed');
  }
}
